<template>
  <button
    class="tw-relative tw-flex tw-h-10 tw-w-10 tw-items-center tw-justify-center tw-rounded-lg tw-text-grey-900 hover:tw-bg-gray-100"
    @click="$emit('click')"
  >
    <q-icon :name="icon" size="20px" />

    <c-menu-badge
      v-if="badge"
      :label="badge.label"
      :color="badge.color"
      :text-color="badge.textColor"
      floating
    />
  </button>
</template>

<script setup lang="ts">
defineProps<{
  icon: string;
  badge?:
    | {
        label: number | string;
        color: string;
        textColor: string;
      }
    | false;
}>();

defineEmits<{
  (event: "click"): void;
}>();
</script>
